(() => {
  const rootSelector = '[data-bloom-learn]';
  const globalKey = '__bloomLearnV2Init';

  if (window[globalKey]) {
    document.querySelectorAll(rootSelector).forEach(window[globalKey]);
    return;
  }

  const init = (root) => {
    if (!root || root.dataset.learnV2Ready === 'true') return;
    root.dataset.learnV2Ready = 'true';

    const chapters = [...root.querySelectorAll('[data-learn-chapter]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const aborter = new AbortController();
    const { signal } = aborter;
    root._learnV2Aborter = aborter;

    const headerOffset = () => {
      const header = document.querySelector('header-component, .site-header');
      return Math.max(18, Math.ceil(header?.getBoundingClientRect().height || 76) + 14);
    };

    const targetFromHash = (hash) => {
      if (!hash || hash === '#') return;
      let id;
      try {
        id = decodeURIComponent(hash.replace(/^#/, ''));
      } catch {
        return;
      }
      return root.querySelector(`#${CSS.escape(id)}`);
    };

    const reveal = (hash, updateHistory = false, moveFocus = false) => {
      const target = targetFromHash(hash);
      if (!target) return;

      const targetChapter = target.closest('[data-learn-chapter]');
      if (targetChapter) {
        chapters.forEach((chapter) => {
          if (chapter !== targetChapter) chapter.open = false;
        });
        targetChapter.open = true;
      }

      if (updateHistory && window.location.hash !== hash) {
        window.history.pushState(null, '', hash);
      }

      window.requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
        window.scrollTo({
          top,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });

        if (moveFocus) {
          const focusTarget = target.matches('[data-learn-chapter]')
            ? target.querySelector(':scope > summary')
            : target;
          focusTarget?.focus({ preventScroll: true });
        }
      });
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
      if (!link.matches('[data-learn-jump]') && !link.closest('#LearnMenu')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      if (!targetFromHash(url.hash)) return;
      event.preventDefault();
      queueMicrotask(() => reveal(url.hash, true, true));
    }, { signal });

    window.addEventListener('hashchange', () => reveal(window.location.hash), { signal });

    if (window.location.hash) {
      window.requestAnimationFrame(() => reveal(window.location.hash));
    }
  };

  window[globalKey] = init;

  const initAll = () => document.querySelectorAll(rootSelector).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.(rootSelector)
      ? event.target
      : event.target.querySelector?.(rootSelector);
    init(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(rootSelector)
      ? event.target
      : event.target.querySelector?.(rootSelector);
    root?._learnV2Aborter?.abort();
  });
})();
